import eventGateway from '~/routes/_shared/events/eventGateway';

type PushNotifications = 'partner_document_created';
export type SettingEvents = 'settings:documents:document_uploaded';

eventGateway.registerMappings<PushNotifications, SettingEvents>([
  {
    from: 'partner_document_created',
    to: 'settings:documents:document_uploaded',
  },
]);
